export const apiBadgeStoreTypes: {
  common: 'COMMON';
  uncommon: 'UNCOMMON';
  unique: 'UNIQUE';
  rare: 'RARE';
} = {
  common: 'COMMON',
  uncommon: 'UNCOMMON',
  unique: 'UNIQUE',
  rare: 'RARE',
};

export const badgeStoreTypes: {
  common: 'common';
  uncommon: 'uncommon';
  unique: 'unique';
  rare: 'rare';
} = {
  common: 'common',
  uncommon: 'uncommon',
  unique: 'unique',
  rare: 'rare',
};

export const badgeStoreTabs: {
  all: 'all';
  minted: 'minted';
  notMinted: 'notMinted';
} = {
  all: 'all',
  minted: 'minted',
  notMinted: 'notMinted',
};

export const badgeStoreStatuses: {
  available: 'available';
  locked: 'locked';
} = {
  available: 'available',
  locked: 'locked',
};

export const mapApiBadgeStoreTypes: {
  [apiBadgeStoreTypes.common]: typeof badgeStoreTypes.common;
  [apiBadgeStoreTypes.uncommon]: typeof badgeStoreTypes.uncommon;
  [apiBadgeStoreTypes.unique]: typeof badgeStoreTypes.unique;
  [apiBadgeStoreTypes.rare]: typeof badgeStoreTypes.rare;
} = {
  [apiBadgeStoreTypes.common]: badgeStoreTypes.common,
  [apiBadgeStoreTypes.uncommon]: badgeStoreTypes.uncommon,
  [apiBadgeStoreTypes.unique]: badgeStoreTypes.unique,
  [apiBadgeStoreTypes.rare]: badgeStoreTypes.rare,
};

export type BadgeStoreStatuses = keyof typeof badgeStoreStatuses;

export type BadgeStoreTypes = keyof typeof badgeStoreTypes;
